'use client';

import { memo } from 'react';
import { useTranslations } from 'next-intl';
import clsx from 'clsx';

import { Question } from '@entities/quiz';
import { Radio } from '@shared/ui/components';

import styles from './SingleQuestion.module.scss';

interface SingleQuestionProps {
  index: number;
  question: Question;
  value: string;
  isPassed: boolean;
  disabled?: boolean;
  isCorrect?: boolean;
  rightAnswerId?: string;
  className?: string;
  onChange: (questionId: string, option: string | null, text: string | null) => void;
}

const SingleQuestion = memo((props: SingleQuestionProps) => {
  const {
    index,
    value,
    question,
    isPassed,
    disabled,
    isCorrect,
    rightAnswerId,
    className,
    onChange,
  } = props;

  const t = useTranslations('quiz');

  return (
    <div className={clsx(styles.container, className)}>
      <div className={styles.scope}>
        <div className={styles.question_title}>
          {t('question')} #{index}
        </div>

        <div className={styles.question_text}>{question.text}</div>
      </div>

      <div className={styles.scope}>
        <div className={styles.answer_title}>{t('yourAnswer')}</div>

        <div className={styles.answer_content}>
          <Radio
            value={value || ''}
            options={question.answers.map((answer) => ({
              value: answer.id,
              label: (
                <span
                  className={clsx(
                    rightAnswerId === answer.id && (isPassed || isCorrect) && styles.label_correct,
                    rightAnswerId &&
                      rightAnswerId !== answer.id &&
                      value === answer.id &&
                      isPassed &&
                      styles.label_wrong,
                  )}
                >
                  {answer.text}
                </span>
              ),
            }))}
            disabled={disabled || isPassed || isCorrect}
            onChange={(id) => onChange(question.id, id, null)}
          />
        </div>

        {isCorrect !== undefined && (
          <div
            className={clsx(styles.result, isCorrect ? styles.result_correct : styles.result_wrong)}
          >
            {t(isCorrect ? 'correctAnswer' : 'wrongAnswer')}
          </div>
        )}
      </div>
    </div>
  );
});

export default SingleQuestion;
